import styled from '@emotion/styled';
import { Paragraph2 } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

export const MarketReviewWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ReviewInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const MarketReviewContainer = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 100%;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const ImgBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 6px;
  top: 6px;
  border-radius: 100%;
  width: 22px;
  height: 22px;
  background: ${colors.orange900};
`;

export const ProductTitle = styled(Paragraph2)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ReviewContent = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;
